import React, { useState } from "react";
import { message } from "antd";
// import "../Styles/PostGPSRouter.css";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Fade,
  Slide,
} from "@mui/material";

const PostGPS = () => {
  const [name, setName] = useState("");
  const [serial_number, setSerial_number] = useState("");
  const [imei, setImei] = useState("");
  const [iccid, setIccid] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleReset = () => {
    setName("");
    setSerial_number("");
    setImei("");
    setIccid("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      message.warning("Please enter Name");
      return;
    }
    if (!serial_number || !imei || !iccid) {
      message.warning("Please fill all fields");
      return;
    }

    setSubmitting(true);
    try {
      let formData = new FormData();
      formData.append("name", name.trim());
      formData.append("serial_number", String(serial_number).trim());
      formData.append("imei", String(imei).trim());
      formData.append("iccid", String(iccid).trim());

      const res = await fetch("https://uktomars.co.uk/api/gps-device", {
        method: "POST",
        body: formData,
      });
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      // eslint-disable-next-line no-unused-vars
      const data = await res.json();
      message.success("Form submitted successfully");
      window.location.href = "/";
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to submit form. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ maxWidth: 1000, mx: "auto", my: 5, px: 2 }}>
        <Slide direction="up" in={true} timeout={400}>
          <Paper elevation={6} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
            <Box component="form" onSubmit={handleSubmit}>
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Creates a new GPS device
                </Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name GPS"
                    placeholder="Name GPS"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="serial number"
                    placeholder="serial_number"
                    value={serial_number}
                    onChange={(e) => setSerial_number(e.target.value)}
                    required
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="imei"
                    placeholder="imei"
                    value={imei}
                    onChange={(e) => setImei(e.target.value)}
                    required
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="iccid"
                    placeholder="iccid"
                    value={iccid}
                    onChange={(e) => setIccid(e.target.value)}
                    required
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", gap: 2, justifyContent: "center" }}
                  >
                    <Button variant="outlined" onClick={handleReset}>
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={submitting}
                    >
                      {submitting ? "Submitting..." : "Submit"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Slide>
      </Box>
    </Fade>
  );
};

export default PostGPS;
